import React from "react";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { BRAND_ASSETS } from "@/lib/brandAssets";
import { useSiteContent } from "@/context/SiteContentContext";

export default function AboutPage() {
  const { t } = useSiteContent();
  return (
    <div className="club-theme min-h-screen" data-testid="about-page">
      <PublicHeader />
      <section className="max-w-4xl mx-auto px-6 md:px-12 pt-20 pb-16">
        <div className="bloom-divider mb-6">✦ The Manifesto ✦</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[0.95]">{t("about.headline", "An heirloom flower society.")}</h1>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-8 space-y-6 font-serif text-lg text-[var(--bloom-ink)] leading-[1.85]">
            <p className="italic text-2xl text-[var(--bloom-brand)]">
              {t("about.body", "Heritage Bloom Club is a slow, considered flower subscription. We work with a small network of independent growers across Aotearoa to bring you seasonal, locally-grown blooms.")}
            </p>
            <p>
              Customers sign up to receive a seasonal bloom box filled with freshly picked dahlias and complementary flowers,
              all grown by farmers in their own region. The flowers arrive flat laid and unarranged, allowing customers to create
              something beautiful themselves at home. Part flower delivery, part creative experience, part connection to the seasons.
            </p>
            <p>
              What makes the idea unique is that it doesn't rely on flowers being shipped around the country. Local flower farms service
              their own communities. Heritage Dahlias handles the brand, customer experience and subscriptions, while participating growers
              harvest, pack and deliver from their own farms.
            </p>
            <p className="italic">
              Local flowers, grown by local people, delivered fresh, and enjoyed in a way that brings a little creativity and beauty into everyday life.
            </p>
          </div>
          <div className="md:col-span-4">
            <img src={BRAND_ASSETS.peony} alt="Heritage Bloom Club" className="w-full max-w-[280px] mx-auto" style={{ filter: "drop-shadow(0 12px 36px rgba(0,0,0,0.18))" }} />
          </div>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
